export class LoadMap {
  constructor(config) {
    this.mapType = new google.maps.StyledMapType(config.style);
    this.mapOption = config.option;
    if (document.getElementById(config.id) !== null) {
      this.gmap = new google.maps.Map(document.getElementById(config.id), this.mapOption);
      this.gmap.setMapTypeId(google.maps.MapTypeId.ROADMAP);
      this.gmap.mapTypes.set('styled_map', this.mapType);
      this.gmap.setMapTypeId('styled_map');
      google.maps.event.addDomListener(window, "resize", () => {
        let center = this.gmap.getCenter();
        google.maps.event.trigger(this.gmap, "resize");
        this.gmap.setCenter(center);
      });
    }else{
      this.gmap = false;
    }
  }
  get gmap(){
    return this._gmap;
  }
  set gmap(gmap){
    this._gmap = gmap;
  }
}

export class MapMarker {
  constructor(mapConfig,markerInfo) {
    this.mapConfig = mapConfig;
    this.markerInfo = markerInfo;
    this.option = {
      title: markerInfo['id'],
      animation: markerInfo['animation']
    };
    this.marker = new google.maps.Marker(this.option);
    this.mapForAllFlag = false;

    if(markerInfo['image']){
      this.marker.setIcon(markerInfo['image']);
    }
  }
  initForAll(mapForAll){
    this.mapForAllFlag = true;
    this.markerForAll = new google.maps.Marker(this.option);
    this.mapForAll = mapForAll;
  }
  getLocation() {
    let geocoder;
    geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({
        'address': this.markerInfo['address']
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results[0].geometry.location);
        } else {
          reject(status);
        }
      });
    });
  }
  setGoogleMap(){
    return this.getLocation().then(location =>{
      this.map = new LoadMap(this.mapConfig);
      if(this.map.gmap !== false){
        this.marker.setPosition(location);
        this.map.gmap.setCenter(location);
        if (this.markerInfo['set'] === true) {
          this.marker.setMap(this.map.gmap);
        }
      }
      if(this.mapForAllFlag){
        this.markerForAll.setPosition(location);
        if (this.markerInfo['set'] === true && this.mapForAll.gmap !== false) {
          this.markerForAll.setMap(this.mapForAll.gmap);
        }
      }
      return Promise.resolve(location);
    }, err =>{
      console.log(this.markerInfo['address']+" not search");
    });
  }
}

export class MapControl{
  constructor(className,mapConfig){
    this.className = className;
    this.mapConfig = mapConfig;
    this.mapAllBounds = [];
    let mapAllConfig;
    if (this.mapConfig.all) {
      mapAllConfig = JSON.parse(JSON.stringify(this.mapConfig.map));
      mapAllConfig.id = this.className + '-all';
      this.mapAllBounds = new google.maps.LatLngBounds();
      this.mapAll = new LoadMap(mapAllConfig);
    }
    this.setMarker();
  }
  setMarker(){
    let mapConfig,marker;
    for (var key in this.mapConfig.makers) {
      mapConfig = JSON.parse(JSON.stringify(this.mapConfig.map));
      mapConfig.id = this.className + '-' + this.mapConfig.makers[key]['id'];
      marker = new MapMarker(mapConfig,this.mapConfig.makers[key]);
      if(this.mapConfig.all){
        marker.initForAll(this.mapAll);
        marker.setGoogleMap().then(location =>{
          if(this.mapAll.gmap !== false){
            this.mapAllBounds.extend(location);
            this.mapAll.gmap.fitBounds(this.mapAllBounds);
          }
        },err =>{
          console.log("all map is error");
        });
      }else{
        marker.setGoogleMap();
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  let mapApiKey,script;

  mapApiKey = 'AIzaSyAuMhL9Wlbp3PPrgZLNCduBK3Ehtx3TbyA';

  script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://maps.googleapis.com/maps/api/js?callback=window.initMap&key='+mapApiKey;
  document.getElementsByTagName('head')[0].appendChild(script);

});

function initMap() {
  let mapOption,mapStyle,markersArr,mapConfig;

  mapOption = {
    zoom: 14,
    disableDefaultUI: true,
    scaleControl: false,
    scrollwheel: false,
    draggable: false,
    disableDoubleClickZoom: true,
  };
  mapStyle = [];
  markersArr = [
    {id: 'oonogi', name: 'おおのぎこどもファミリー歯科', address: '愛知県名古屋市西区大野木１-２３６', 'set': true,'image':'http://localhost:3004/img/common/icon-marker.png'},
  ];
  mapConfig = {map:{option:mapOption,style: mapStyle},makers:markersArr,all:false};

  new MapControl('js-gmap',mapConfig);
}

window.initMap = initMap;

